/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DestinationAWSKinesis,
  DestinationAWSKinesis$inboundSchema,
  DestinationAWSKinesis$Outbound,
  DestinationAWSKinesis$outboundSchema,
} from "./destinationawskinesis.js";
import {
  DestinationAwss3,
  DestinationAwss3$inboundSchema,
  DestinationAwss3$Outbound,
  DestinationAwss3$outboundSchema,
} from "./destinationawss3.js";
import {
  DestinationAWSSQS,
  DestinationAWSSQS$inboundSchema,
  DestinationAWSSQS$Outbound,
  DestinationAWSSQS$outboundSchema,
} from "./destinationawssqs.js";
import {
  DestinationAzureServiceBus,
  DestinationAzureServiceBus$inboundSchema,
  DestinationAzureServiceBus$Outbound,
  DestinationAzureServiceBus$outboundSchema,
} from "./destinationazureservicebus.js";
import {
  DestinationGCPPubSub,
  DestinationGCPPubSub$inboundSchema,
  DestinationGCPPubSub$Outbound,
  DestinationGCPPubSub$outboundSchema,
} from "./destinationgcppubsub.js";
import {
  DestinationHookdeck,
  DestinationHookdeck$inboundSchema,
  DestinationHookdeck$Outbound,
  DestinationHookdeck$outboundSchema,
} from "./destinationhookdeck.js";
import {
  DestinationRabbitMQ,
  DestinationRabbitMQ$inboundSchema,
  DestinationRabbitMQ$Outbound,
  DestinationRabbitMQ$outboundSchema,
} from "./destinationrabbitmq.js";
import {
  DestinationWebhook,
  DestinationWebhook$inboundSchema,
  DestinationWebhook$Outbound,
  DestinationWebhook$outboundSchema,
} from "./destinationwebhook.js";

export type Destination =
  | DestinationWebhook
  | DestinationAWSSQS
  | DestinationRabbitMQ
  | DestinationHookdeck
  | DestinationAWSKinesis
  | DestinationAzureServiceBus
  | DestinationAwss3
  | DestinationGCPPubSub;

/** @internal */
export const Destination$inboundSchema: z.ZodType<
  Destination,
  z.ZodTypeDef,
  unknown
> = z.union([
  DestinationWebhook$inboundSchema,
  DestinationAWSSQS$inboundSchema,
  DestinationRabbitMQ$inboundSchema,
  DestinationHookdeck$inboundSchema,
  DestinationAWSKinesis$inboundSchema,
  DestinationAzureServiceBus$inboundSchema,
  DestinationAwss3$inboundSchema,
  DestinationGCPPubSub$inboundSchema,
]);
/** @internal */
export type Destination$Outbound =
  | DestinationWebhook$Outbound
  | DestinationAWSSQS$Outbound
  | DestinationRabbitMQ$Outbound
  | DestinationHookdeck$Outbound
  | DestinationAWSKinesis$Outbound
  | DestinationAzureServiceBus$Outbound
  | DestinationAwss3$Outbound
  | DestinationGCPPubSub$Outbound;

/** @internal */
export const Destination$outboundSchema: z.ZodType<
  Destination$Outbound,
  z.ZodTypeDef,
  Destination
> = z.union([
  DestinationWebhook$outboundSchema,
  DestinationAWSSQS$outboundSchema,
  DestinationRabbitMQ$outboundSchema,
  DestinationHookdeck$outboundSchema,
  DestinationAWSKinesis$outboundSchema,
  DestinationAzureServiceBus$outboundSchema,
  DestinationAwss3$outboundSchema,
  DestinationGCPPubSub$outboundSchema,
]);

export function destinationToJSON(destination: Destination): string {
  return JSON.stringify(Destination$outboundSchema.parse(destination));
}
export function destinationFromJSON(
  jsonString: string,
): SafeParseResult<Destination, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Destination$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Destination' from JSON`,
  );
}
